import { isMobile, isTablet, isBrowser } from "react-device-detect";

export const isMobileClass = (classType) =>
  isMobile || isTablet ? `view-mobile__${classType}` : `view__${classType}`;

export const isMobileOrTablet = () => (isMobile || isTablet ? true : false);

export const isBrowserView = () => isBrowser;

export const renderContentByView = (mobileContent, desktopContent) => {
  return isMobileOrTablet() ? mobileContent : desktopContent;
};
